import React from 'react';
import { MetricCard } from './MetricCards';
import type { Money } from '../utils/currency';
import type { UnifiedBundle } from '../types/Product';

interface BundleMetricCardsProps {
  /** The bundles currently listed on the page. */
  bundles: UnifiedBundle[];
  money: Money;
}

/**
 * Summary cards at the top of the Asoebi bundles page. These replace the
 * count chip that used to sit in the breadcrumb bar. The total goes through
 * `money.format`, so a project with no currency shows "currency not set" in
 * the card instead of a guessed amount.
 */
const BundleMetricCards: React.FC<BundleMetricCardsProps> = ({ bundles, money }) => {
  if (bundles.length === 0) return null;
  const total = bundles.reduce((sum, b) => sum + b.price, 0);
  const items = bundles.reduce((sum, b) => sum + b.items.length, 0);
  return (
    <section className="stats-grid">
      <MetricCard label="Bundles" value={bundles.length} tone="pink" icon="grid" />
      <MetricCard label="Total value" value={money.format(total)} tone="green" icon="wallet" />
      <MetricCard label="Items" value={items} tone="blue" icon="list" />
    </section>
  );
};

export default BundleMetricCards;
